import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseGatewaysBehindNat from '../../AbstractObjects/GatewayPlan/InnerPages/BaseGatewaysBehindNat';
import Sepperator from '../../../../components/Simple/Sepperator';
import EmptyRow from '../../../../components/Simple/EmptyRow';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import {useTranslation} from 'react-i18next';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import Indentation from '../../../../components/Simple/Indentation';
import {gatewayBehindNetIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.gatewaysBehindNAT;
const pageId = pageSchema.pageId;

function GatewayGatewaysBehindNat({
    gatewayObject,
    planObject,
    setGatewayData
}) {

    const { t } = useTranslation();
    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const setPageValue = useCallback((param, newValue) => {
        setGatewayData([pageId, param], newValue);
    }, [setGatewayData]);
    
    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setPageValue(pageSchema.mgmtPort, planPage[pageSchema.mgmtPort]);
            setPageValue(pageSchema.sicPort, planPage[pageSchema.sicPort]);
        }
        setPageValue([pageSchema.lockedToPlan], locked);
    }, [setPageValue, planPage]);
    
    const accessServiceMode = gatewayPage[pageSchema.accessServiceMode];
    const accessServiceUrl  = gatewayPage[pageSchema.accessServiceUrl];

    return (
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.GATEWAYS_BEHIND_NAT')}
            icon={gatewayBehindNetIcon}
        >
            <BaseGatewaysBehindNat
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
            />
            <EmptyRow />
            <Sepperator />
            <EmptyRow />
            <Indentation>
                <SMCCheckbox
                    disabled={lockedToPlan}
                    checked={accessServiceMode}
                    onChange={e => setPageValue(pageSchema.accessServiceMode, e.target.checked)}
                    label={t('SMP.PLAN.SERVICES.GW_BEHIND_NAT.LINE5')}
                    tooltip={t('SMP.PLAN.SERVICES.GW_BEHIND_NAT.EXAMPLE') + ': https://mygw-web.smbrelay.checkpoint.com'}
                />
                <Indentation>
                    <SMCTextInput
                        disabled={lockedToPlan || !accessServiceMode}
                        width={300}
                        value={accessServiceUrl}
                        onChange={e => setPageValue(pageSchema.accessServiceUrl, e.target.value)}
                    />
                </Indentation>
            </Indentation>
        </LockToPlanContainer>
    );
}

export default GatewayGatewaysBehindNat;